import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {Link} from 'react-router-dom';
import get from 'lodash/get';
import includes from 'lodash/includes';
import capitalize from 'lodash/capitalize';
import {Container, Header} from 'semantic-ui-react';
import PagingBar from 'components/common/PagingBar';
import ItemGrid from 'components/common/ItemGrid';
import {createResourcePageItemsSelector, createResourcePageSelector} from 'resources/selectors';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import {updatePageNumberForResourceAction} from 'resources/actions';
import {pageCount, prependRecentIfFirstPage} from 'utils/DBUtils';
import * as ResourceApi from 'api/resources';
import {
    approveReceiptAction,
    approveSubmissionAction,
    auditReceiptAction,
    deleteSubmissionAction,
    favoriteSubmissionAction,
    setFiltersAction,
    getCampaignsAction,
    getSubmissionsAction,
    rejectReceiptAction,
    resendEmailAction,
    toggleFilterAccordionAction,
    unapproveSubmissionAction,
    unfavoriteSubmissionAction,
    updateSearchQueryAction
} from './actions';
import createPlatformFilter from './PlatformFilter';
import UGCSubmission from './UGCSubmission';
import Spinner from './Spinner';
import {ReceiptProcessingStatusOptions, UGC_PLATFORMS, UgcStatusOptions} from './utils';
import UGCReceiptSubmission from "./UGCReceiptSubmission";
import BasicAccordion from "../../components/common/BasicAccordion";

function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

const mapStateToProps = (state, ownProps) => {
  const {fetching, currentPlatforms, currentMasterCampaign, additionalFilters} = state.ugc;

  const getResourcePage = createResourcePageSelector(ownProps.ugcResourceType);
  const getPageItems = createResourcePageItemsSelector(ownProps.ugcResourceType);

  const {page, count, total} = getResourcePage(state.resources);
  let submissions = prependRecentIfFirstPage(page, count, [], getPageItems(state.resources));
  const availablePlatforms = Object.keys(get(state.ugc.campaigns, currentMasterCampaign, {}));
  const auditingReceipt = state.ugc.sendingAuditForReceipt;

  const searchResults = state.ugc.searchResults;
  let isSearch = false;
  if (searchResults) {
      submissions = searchResults;
      isSearch = true;
  }

  return {
    availablePlatforms,
    currentPlatforms,
    additionalFilters,
    fetching,
    submissions,
    masterCampaignId: currentMasterCampaign,
    currentPage: page,
    count,
    total,
    auditingReceipt,
    audits: state.ugc.audits,
    sendingEmail: state.ugc.sendingEmail,
    silentRejections: state.ugc.silentRejections,
    errors: state.ugc.errors,
    searchQuery: state.ugc.searchQuery,
      isSearch,
      filterAccordionOpen: state.ugc.filterAccordionOpen
  };
};

const pageSize = 20;
const mapDispatchToProps = dispatch => bindActionCreators({
  setFiltersAction: setFiltersAction,
  getCampaigns: getCampaignsAction,
  getSubmissions: getSubmissionsAction,
  approveSubmission: approveSubmissionAction,
  unapproveSubmission: unapproveSubmissionAction,
  deleteSubmission: deleteSubmissionAction,
  favoriteSubmission: favoriteSubmissionAction,
  unfavoriteSubmission: unfavoriteSubmissionAction,
  auditReceipt: auditReceiptAction,
  approveReceipt: approveReceiptAction,
  rejectReceipt: rejectReceiptAction,
  resendEmail: resendEmailAction,
  updateSearchQuery: updateSearchQueryAction,
  toggleFilterAccordion: toggleFilterAccordionAction
}, dispatch);

const UGCCampaignPage = compose(
  setDisplayName('UGCCampaignPage'),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({

    // we've loaded, through a react-router route
    componentDidMount() {

      console.log("componentDidMount");  
      let filters = parseQuery(this.props.location.search);
      
      for (let key in filters) {
        if (filters[key].indexOf(",") > -1) {
          filters[key] = filters[key].split(",")
        }
      }

      console.log(filters);
      // this.props.setFiltersAction(filters)
      this.props.getCampaigns(this.props.match.params.masterCampaignId, this.props.ugcResourceType, filters);
      // this.props.getSubmissions(this.props.masterCampaignId, this.props.ugcResourceType, this.props.currentPage, [], filters)

    }
  }),
  withProps(props => ({
    onPlatformsSelected: (data) => {
      
      let path = "/ugc/";

      console.log(data);

      if (props.ugcResourceType == "UGCReceiptSubmission") {
        path = "/receipt/";
      }

      path = path + props.masterCampaignId + "?"
      
      for (let key in data) {
        if (typeof data[key] == "array") {
          path = path + key + "=" + data[key].join(",");
        } else {
          path = path + key + "=" + data[key];
        }

        path = path + "&";
      }

      // trim trailing & 
      if (path.endsWith("&")) {
        path = path.substr(0, path.length - 1);
      }

      console.log(path);
      // props.setFiltersAction(data)

      // use rect-router to trigger content update, not redux here. redux gets triggered in componentDidMount 
      props.history.push(path)
      // props.getSubmissions(props.masterCampaignId, props.ugcResourceType, props.currentPage, [], data)

    },
    gridProps: {
      items: props.submissions,
      rowCount: 2,
      colCount: 5,
      cellFunc: submission => {
        let moreProps = {
            ...submission,
            approveSubmission: () => props.approveSubmission(submission.id),
            unapproveSubmission: () => props.unapproveSubmission(submission.id),
            deleteSubmission: () => props.deleteSubmission(submission.id),
            favoriteSubmission: () => props.favoriteSubmission(submission.id),
            unfavoriteSubmission: () => props.unfavoriteSubmission(submission.id),
            updateSearchQuery: (query) => props.updateSearchQuery(submission.id, query)
            
        };

        let audit = props.audits[submission.id];
        let sendingEmail = props.sendingEmail[submission.id];
        let error = props.errors[submission.id] || {};

        let receipt = <UGCReceiptSubmission masterCampaignId={props.masterCampaignId}
                                            auditReceipt={props.auditReceipt}
                                            approveReceipt={props.approveReceipt}
                                            rejectReceipt={props.rejectReceipt}
                                            resendEmail={props.resendEmail}
                                            auditingReceipt={props.auditingReceipt === submission.id}
                                            auditAction={audit && audit.action}
                                            sendingEmail={sendingEmail}
                                            error={error.reason}
                                            silentRejection={props.silentRejections[submission.id] || false}
                                            {...moreProps}/>;
        return submission.resourceId.type === "UGCReceiptSubmission" ? receipt : <UGCSubmission {...moreProps}/>;
      }
    },
    pagingProps: {
      count: pageCount(props.total, pageSize),
      total: props.total,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: page => props.getSubmissions(props.masterCampaignId, props.ugcResourceType, page),
      onNextClicked: () => props.getSubmissions(props.masterCampaignId, props.ugcResourceType, props.currentPage + 1),
      onPreviousClicked: () => props.getSubmissions(props.masterCampaignId, props.ugcResourceType, props.currentPage - 1)
    }
  }))
)(props => {
  
  const platformFilterOptions = UGC_PLATFORMS.map(platform => ({
    key: platform,
    value: platform,
    text: capitalize(platform),
    disabled: !includes(props.availablePlatforms, platform)
  }));

    const PlatformFilter = createPlatformFilter({
        platforms: props.currentPlatforms,
        ...props.additionalFilters
    }, {
        fields: [
            {
                type: 'text',
                name: 'searchQuery',
                props: {
                    label: "Search"
                }
            },
            {
                type: 'text',
                name: 'userId',
                props: {
                    label: "User Id"
                }
            },
            {
              type: 'text',
              name: 'ipAddress',
              props: {
                  label: "IP Address"
              }
          },
          {
                type: 'text',
                name: 'rewardEmail',
                props: {
                    label: "Email"
                }
            },
            {
                type: 'checkbox',
                name: 'platforms',
                props: {
                    label: "Platform",
                    options: platformFilterOptions
                }
            },
            {
                type: 'checkbox',
                name: 'status',
                props: {
                    label: "Status",
                    options: UgcStatusOptions
                }
            },
            {
                type: 'checkbox',
                name: 'processingStatus',
                props: {
                    label: "Processing Status",
                    options: ReceiptProcessingStatusOptions
                }
            },
            {
                type: 'label',
                props: {
                    text: "Date Range"
                }
            },
            {
                type: 'date',
                name: 'fromDate',
                props: {
                    label: "From"
                }
            },
            {
                type: 'date',
                name: 'toDate',
                props: {
                    label: "To"
                }
            }
        ]
    });

  return (
    <div className='ugc-campaign-view'>
      <Header as='h1'>UGC Submissions</Header>
      <BasicAccordion header={"Filters"}
                      active={props.filterAccordionOpen}
                      onClick={props.toggleFilterAccordion}>
          <PlatformFilter
              loading={props.fetching}
              onSaveData={props.onPlatformsSelected} />
      </BasicAccordion>
      <Link to='/ugc'>Back to all campaigns</Link>
      <div className='ugc-submissions-view'>
        {props.fetching ? <Spinner /> : (
          <Fragment>
            {props.submissions.length ? <ItemGrid {...props.gridProps} /> : (
              <Container textAlign='center'>
                <Header as='h3' block>
                  No submissions found
                </Header>
              </Container>
            )}

              {props.isSearch ? "" : (
                  <PagingBar {...props.pagingProps} />
              )}
          </Fragment>
        )}
      </div>
    </div>
  );
});

export default UGCCampaignPage;



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/UGCCampaignPage.jsx